import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Loader2 } from "lucide-react";

const AGENTE_ROTAS = ["/dashboard", "/cobranca-diaria", "/rota-cobranca", "/clientes", "/contratos", "/parcelas", "/pagamentos", "/acordos", "/documentos"];

export default function ProtectedRoute({ children, master }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading || user === null)
    return (
      <div className="min-h-screen flex items-center justify-center bg-onyx">
        <Loader2 className="w-8 h-8 animate-spin gold-text" />
      </div>
    );
  if (!user) return <Navigate to={`/login?next=${encodeURIComponent(location.pathname + location.search)}`} replace />;
  if (master && user.platform_role !== "superadmin") return <Navigate to="/dashboard" replace />;
  if (user.role === "agente_campo" && !AGENTE_ROTAS.some((p) => location.pathname === p || location.pathname.startsWith(p + "/"))) return <Navigate to="/dashboard" replace />;
  return children;
}
